import { useEffect, useRef } from 'react';

import { useAuth } from '../context/AuthContext';

const useRevealSessionCheck = (enabled: boolean): void => {
  const { refreshSession } = useAuth();
  const prevEnabledRef = useRef(false);

  useEffect(() => {
    if (enabled && !prevEnabledRef.current)
      void refreshSession();
    prevEnabledRef.current = enabled;
  }, [enabled, refreshSession]);
};

export default useRevealSessionCheck;
